import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiHome, FiArrowLeft, FiSearch, FiMail } = FiIcons;

const NotFound = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <div className="flex-1 flex items-center justify-center px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center max-w-2xl"
        >
          {/* Error Code */}
          <motion.div
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="mb-8"
          >
            <h1 className="text-9xl font-bold text-orange-500">404</h1>
          </motion.div>

          {/* Error Message */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="mb-8"
          >
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Seite nicht gefunden
            </h2>
            <p className="text-lg text-gray-600 mb-6">
              Die gesuchte Seite existiert leider nicht oder wurde entfernt.
              Vielleicht haben Sie sich vertippt oder der Link ist veraltet.
            </p>
          </motion.div>

          {/* Action Buttons */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.6 }}
            className="flex flex-col sm:flex-row gap-4 justify-center mb-12"
          >
            <Link
              to="/"
              className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-3 rounded-lg font-semibold transition-colors duration-200 inline-flex items-center justify-center space-x-2"
            >
              <SafeIcon icon={FiHome} className="w-5 h-5" />
              <span>Zur Startseite</span>
            </Link>
            <button
              onClick={() => window.history.back()}
              className="border-2 border-orange-500 text-orange-500 hover:bg-orange-500 hover:text-white px-8 py-3 rounded-lg font-semibold transition-colors duration-200 inline-flex items-center justify-center space-x-2"
            >
              <SafeIcon icon={FiArrowLeft} className="w-5 h-5" />
              <span>Zurück</span>
            </button>
          </motion.div>

          {/* Help Section */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.8 }}
            className="bg-white rounded-xl shadow-lg p-8 text-left"
          >
            <h3 className="text-xl font-semibold text-gray-900 mb-4 flex items-center">
              <SafeIcon icon={FiSearch} className="w-6 h-6 text-orange-500 mr-3" />
              Wie können wir Ihnen helfen?
            </h3>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <h4 className="font-semibold text-gray-900 mb-2">Suchen Sie nach:</h4>
                <ul className="space-y-2 text-gray-600">
                  <li>• Informationen zu unseren <Link to="/services" className="text-orange-500 hover:text-orange-600">Leistungen</Link></li>
                  <li>• Details über unser <Link to="/team" className="text-orange-500 hover:text-orange-600">Team</Link></li>
                  <li>• Unsere <Link to="/references" className="text-orange-500 hover:text-orange-600">Referenzen</Link></li>
                  <li>• Aktuelle <Link to="/blog" className="text-orange-500 hover:text-orange-600">Blog-Artikel</Link></li>
                </ul>
              </div>
              
              <div>
                <h4 className="font-semibold text-gray-900 mb-2">Direkter Kontakt:</h4>
                <ul className="space-y-2 text-gray-600">
                  <li>• Telefon: <a href="tel:+41441234567" className="text-orange-500 hover:text-orange-600">+41 44 123 45 67</a></li>
                  <li>• E-Mail: <a href="mailto:info@hubler-tex.ch" className="text-orange-500 hover:text-orange-600">info@hubler-tex.ch</a></li>
                  <li>• WhatsApp: <a href="https://wa.me/41791234567" className="text-orange-500 hover:text-orange-600">24/7 Verfügbar</a></li>
                </ul>
              </div>
            </div>

            <div className="mt-6 pt-6 border-t border-gray-200">
              <div className="flex items-center justify-between">
                <p className="text-sm text-gray-600">
                  Benötigen Sie Unterstützung? Unser Team steht Ihnen gerne zur Verfügung.
                </p>
                <Link
                  to="/contact"
                  className="text-orange-500 hover:text-orange-600 font-semibold flex items-center space-x-1"
                >
                  <SafeIcon icon={FiMail} className="w-4 h-4" />
                  <span>Kontakt aufnehmen</span>
                </Link>
              </div>
            </div>
          </motion.div>
        </motion.div>
      </div>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-8">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <p className="text-gray-400 text-sm">
            © 2024 Hubler & Tex Facility Management Services. Alle Rechte vorbehalten.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default NotFound;